const demoindex = (r) =>
  require.ensure([], () => r(require('@/page/demo/index.vue')), 'demoindex');

const demoindexRouter = {
  path: '',
  name: '智慧物业监管',
  component: demoindex,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: false,
  },
  children: [
    {
      path: '/demoindex',
      component: demoindex,
      name: '智慧物业监管',
      meta: {
        right: ['智慧物业监管'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
  ],
};
export default demoindexRouter;
